import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { getRankingList, updateRanking } from "../../Redux/Actions/rankingActions";
import { columnsBuildersRanking } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import CityDropdown from "./cityDropDown";
import RankingEditModal from "./updateRankingPopup";

const ListBuilderRating = () => {
    const dispatch = useDispatch();

    const [searchQuery, setSearchQuery] = useState("");
    const [cityId, setCityId] = useState("6808dd3def8fb1411ef46efa");
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });

    const [isRankingModalVisible, setIsRankingModalVisible] = useState(false);
    const [selectedBuilder, setSelectedBuilder] = useState(null);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { rankings, loading } = useSelector((state) => state.ranking);
    const { citiesList = { data: [] } } = useSelector((state) => state.city || {});

    useEffect(() => {
        if (citiesList.data.length && !cityId) {
            const mohali = citiesList.data.find(
                city => city.city_name.toLowerCase() === "mohali"
            );

            if (mohali) {
                setCityId(mohali._id);
            }
        }
    }, [citiesList, cityId]);


    const fetchDetails = useCallback(
        async (page, limit, showLoader = true) => {
            const rankingData = {
                page,
                limit,
                is_deleted: false,
                filter: debouncedSearch,
                ...(dateRange.start && {
                    start_date: dateRange.start.format("YYYY-MM-DD"),
                }),
                ...(dateRange.end && {
                    end_date: dateRange.end.format("YYYY-MM-DD"),
                }),
                ...(cityId && { city: cityId }),
            };

            await dispatch(getRankingList(rankingData, showLoader));
        },
        [dispatch, debouncedSearch, cityId, dateRange]
    );

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize, false);
    }, [
        pagination.current,
        pagination.pageSize,
        debouncedSearch,
        cityId,
        dateRange,
        fetchDetails,
    ]);

    useEffect(() => {
        if (typeof rankings?.total === "number") {
            setPagination((prev) => ({
                ...prev,
                total: rankings.total,
            }));
        }
    }, [rankings]);

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleTableChange = (pager) => {
        setPagination((prev) => ({
            ...prev,
            current: pager.current,
            pageSize: pager.pageSize,
        }));
    };

    const handleOpenRankingModal = (record) => {
        setSelectedBuilder(record);
        setIsRankingModalVisible(true);
    };

    const handleCloseRankingModal = () => {
        setIsRankingModalVisible(false);
        setSelectedBuilder(null);
    };

    const handleSaveRanking = async (payload) => {
        try {
            await dispatch(updateRanking(payload));
            toast.success("Ranking updated successfully!");
            handleCloseRankingModal();
            fetchDetails(pagination.current, pagination.pageSize, false);
        } catch (error) {
            console.error("Failed to update ranking", error);
            toast.error("Failed to update ranking");
        }
    };

    const handleCityChange = (e) => {
        const selectedCityId = e.target.value
        setCityId(selectedCityId);
        setPagination(prev => ({ ...prev, current: 1 }));
    };

    return (
        <>
            <div className="bookings_table">
                <div className="table_component_all">
                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading="Builder Rankings"
                            setState={setSearchQuery}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                    </div>

                    <div style={{
                        position: "static",
                        marginTop: "-73px",
                        marginLeft: "86%",
                        marginBottom: "24px"
                    }}>
                        <CityDropdown
                            value={cityId}
                            onChange={handleCityChange}
                        />
                    </div>

                    <div className="custom_table">
                        <div style={{ width: "90%" }}>
                            <Table
                                dataSource={(Array.isArray(rankings?.data) && rankings.data) || []}
                                virtual
                                scroll={{ x: 1700, y: 500 }}
                                pagination={pagination}
                                onChange={handleTableChange}
                                loading={loading}
                                columns={columnsBuildersRanking(pagination.current, pagination.pageSize, handleOpenRankingModal)}
                                rowClassName={() => "text-center"}
                                rowKey={(record) => record._id || record.builder_id}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />

            <RankingEditModal
                visible={isRankingModalVisible}
                onClose={handleCloseRankingModal}
                builderData={selectedBuilder}
                onSave={handleSaveRanking}
            />
        </>
    );
};

export default ListBuilderRating;